import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 90000 });

export const api = {
  createSession: async (demo = true) => (await http.post(`/session`, { demo })).data,
  getSession: async (sid) => (await http.get(`/session/${sid}`)).data,
  reset: async (sid) => (await http.post(`/session/${sid}/reset`)).data,

  message: async (sid, message) => (await http.post(`/session/${sid}/message`, { message })).data,
  linkedin: async (sid, body) => (await http.post(`/session/${sid}/linkedin`, body)).data,
  confirmProfile: async (sid, body) => (await http.post(`/session/${sid}/profile/confirm`, body)).data,
  worked: async (sid, selected) => (await http.post(`/session/${sid}/worked`, { selected })).data,
  assessmentStart: async (sid) => (await http.post(`/session/${sid}/assessment/start`)).data,
  generatePathway: async (sid) => (await http.post(`/session/${sid}/pathway/generate`)).data,
  applyPathway: async (sid, body) => (await http.post(`/session/${sid}/pathway/apply`, body)).data,
  decision: async (sid, body) => (await http.post(`/session/${sid}/pathway/decision`, body)).data,
  programMatch: async (sid) => (await http.post(`/session/${sid}/program/match`)).data,
  applicationStart: async (sid) => (await http.post(`/session/${sid}/application/start`)).data,
  applicationSubmit: async (sid, body) => (await http.post(`/session/${sid}/application/submit`, body)).data,

  uploadCV: async (sid, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return (await http.post(`/session/${sid}/cv`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })).data;
  },

  graph: async () => (await http.get(`/graph`)).data,
};
